import React from "react";
import { TextField, Typography } from "@firecms/ui";

interface BatchDelayFieldProps {
  label?: string;
  valueSec: number;
  onChangeSec: (sec: number) => void;
  disabled?: boolean;
}

/** Seconds between batch operations (rate limiting for Vertex / Unsplash). */
export function BatchDelayField({
  label = "Delay between operations (seconds)",
  valueSec,
  onChangeSec,
  disabled,
}: BatchDelayFieldProps) {
  return (
    <div className="flex flex-col gap-1 max-w-xs mb-4">
      <TextField
        label={label}
        type="number"
        value={String(valueSec)}
        disabled={disabled}
        onChange={(e) => {
          const n = parseInt(e.target.value, 10);
          onChangeSec(Number.isFinite(n) && n >= 0 ? Math.min(n, 600) : 0);
        }}
      />
      <Typography variant="caption" className="text-gray-500">
        Use a higher delay if Vertex AI or Unsplash rate-limits batch runs.
      </Typography>
    </div>
  );
}
